/**
 * @fuegokit/tokens 0.14.0
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 15:29:27 GMT
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
  scale: {
    gray: {
      "100": "#EBECF0",
      "200": "#DFE1E6",
      "300": "#C1C7D0",
      "400": "#8993A4",
      "500": "#6B778C",
      "600": "#57606a",
      "700": "#424a53",
      "800": "#32383f",
      "900": "#24292f",
      "000": "#FAFBFC",
    },
    neutral: {
      "100": "#F7F8F9",
      "200": "#F1F2F4",
      "300": "#DCDFE4",
      "400": "#B3B9C4",
      "500": "#8590A2",
      "600": "#758195",
      "700": "#626F86",
      "800": "#44546F",
      "900": "#2C3E5D",
      "1000": "#172B4D",
      "1100": "#091E42",
      "000": "#FFFFFF",
    },
    neutralAlpha: {
      "100": "#091e4208",
      "200": "#091e420f",
      "300": "#091e4224",
      "400": "#091e4224",
      "500": "#091e427d",
      "000": "#ffffff00",
    },
    blue: {
      "100": "#CCE0FF",
      "200": "#85B8FF",
      "300": "#579DFF",
      "400": "#388BFF",
      "500": "#1D7AFC",
      "600": "#0C66E4",
      "700": "#0055CC",
      "800": "#09326C",
      "900": "#092957",
      "000": "#E9F2FF",
    },
    teal: {
      "100": "#C1F0F5",
      "200": "#8BDBE5",
      "300": "#60C6D2",
      "400": "#37B4C3",
      "500": "#1D9AAA",
      "600": "#1D7F8C",
      "700": "#206B74",
      "800": "#1D474C",
      "900": "#153337",
      "000": "#E3FAFC",
    },
    purple: {
      "100": "#DFD8FD",
      "200": "#B8ACF6",
      "300": "#9F8FEF",
      "400": "#8F7EE7",
      "500": "#8270DB",
      "600": "#6E5DC6",
      "700": "#5E4DB2",
      "800": "#352C63",
      "900": "#15373B",
      "000": "#F3F0FF",
    },
    green: {
      "100": "#BAF3DB",
      "200": "#7EE2B8",
      "300": "#4BCE97",
      "400": "#2ABB7F",
      "500": "#22A06B",
      "600": "#1F845A",
      "700": "#216E4E",
      "800": "#164B35",
      "900": "#143C2B",
      "000": "#DFFCF0",
    },
    yellow: {
      "100": "#F8E6A0",
      "200": "#F5CD47",
      "300": "#E2B203",
      "400": "#CF9F02",
      "500": "#B38600",
      "600": "#946F00",
      "700": "#7F5F01",
      "800": "#533F04",
      "900": "#3F3102",
      "000": "#FFF7D6",
    },
    red: {
      "100": "#FFD2CC",
      "200": "#FF9C8F",
      "300": "#F87462",
      "400": "#EF5C48",
      "500": "#E34935",
      "600": "#CA3521",
      "700": "#AE2A19",
      "800": "#601E16",
      "900": "#4F1C16",
      "000": "#FFEDEB",
    },
    orange: {
      "100": "#FFE2BD",
      "200": "#FEC57B",
      "300": "#FAA53D",
      "400": "#F18D13",
      "500": "#D97008",
      "600": "#B65C02",
      "700": "#974F0C",
      "800": "#5F3811",
      "900": "#4A2B0F",
      "000": "#FFF4E5",
    },
    magenta: {
      "100": "#FDD0EC",
      "200": "#F797D2",
      "300": "#E774BB",
      "400": "#DA62AC",
      "500": "#CD519D",
      "600": "#AE4787",
      "700": "#943D73",
      "800": "#50253F",
      "900": "#421F34",
      "000": "#FFECF8",
    },
    lime: {
      "100": "#D3F1A7",
      "200": "#B3DF72",
      "300": "#94C748",
      "400": "#82B536",
      "500": "#6A9A23",
      "600": "#5B7F24",
      "700": "#4C6B1F",
      "800": "#37471F",
      "900": "#2A3818",
      "000": "#EEFBDA",
    },
  },
  text: {
    default: "#172B4D",
    subtle: "#44546F",
    subtlest: "#626F86",
    disabled: "#8590A2",
    inverse: "#FFFFFF",
    brand: "#0C66E4",
    selected: "#0C66E4",
    danger: "#AE2A19",
    success: "#216E4E",
    discovery: "#5E4DB2",
    information: "#0055CC",
    accent: {
      blue: {
        default: "#0055CC",
        bolder: "#09326C",
      },
      red: {
        default: "#AE2A19",
        bolder: "#601E16",
      },
      orange: {
        default: "#974F0C",
        bolder: "#5F3811",
      },
      yellow: {
        default: "#7F5F01",
        bolder: "#533F04",
      },
      green: {
        default: "#216E4E",
        bolder: "#164B35",
      },
      purple: {
        default: "#5E4DB2",
        bolder: "#352C63",
      },
      teal: {
        default: "#206B74",
        bolder: "#1D474C",
      },
      magenta: {
        default: "#943D73",
        bolder: "#50253F",
      },
      gray: {
        default: "#44546F",
        bolder: "#091E42",
      },
      lime: {
        default: "#4C6B1F",
        bolder: "#37471F",
      },
    },
    warning: {
      default: "#974F0C",
      inverse: "#172B4D",
    },
  },
  icon: {
    default: "#44546F",
    subtle: "#626F86",
    inverse: "#FFFFFF",
    disabled: "#8590A2",
    brand: "#0C66E4",
    selected: "#0C66E4",
    danger: "#E34935",
    success: "#22A06B",
    discovery: "#8270DB",
    information: "#1D7AFC",
    accent: {
      blue: "#1D7AFC",
      red: "#E34935",
      orange: "#D97008",
      yellow: "#B38600",
      green: "#22A06B",
      purple: "#8270DB",
      teal: "#1D9AAA",
      magenta: "#CD519D",
      gray: "#758195",
      lime: "#6A9A23",
    },
    warning: {
      default: "#D97008",
      inverse: "#172B4D",
    },
  },
  border: {
    default: "#091e4224",
    inverse: "#FFFFFF",
    focused: "#388BFF",
    input: "#091e4224",
    disabled: "#091e420f",
    brand: "#0C66E4",
    selected: "#0C66E4",
    danger: "#E34935",
    warning: "#D97008",
    success: "#22A06B",
    discovery: "#8270DB",
    information: "#1D7AFC",
    subtle: "#091e420f",
    accent: {
      blue: "#1D7AFC",
      red: "#E34935",
      orange: "#D97008",
      yellow: "#B38600",
      green: "#22A06B",
      purple: "#8270DB",
      teal: "#1D9AAA",
      magenta: "#CD519D",
      gray: "#758195",
    },
    table: {
      default: "#091e4224",
    },
  },
  background: {
    disabled: "#F1F2F4",
    accent: {
      blue: {
        subtlest: "#E9F2FF",
        subtler: "#CCE0FF",
        subtle: "#579DFF",
        bolder: "#0C66E4",
      },
      red: {
        subtlest: "#FFEDEB",
        subtler: "#FFD2CC",
        subtle: "#F87462",
        bolder: "#CA3521",
      },
      orange: {
        subtlest: "#FFF4E5",
        subtler: "#FFE2BD",
        subtle: "#FAA53D",
        bolder: "#B65C02",
      },
      yellow: {
        subtlest: "#FFF7D6",
        subtler: "#F8E6A0",
        subtle: "#E2B203",
        bolder: "#946F00",
      },
      green: {
        subtlest: "#DFFCF0",
        subtler: "#BAF3DB",
        subtle: "#4BCE97",
        bolder: "#1F845A",
      },
      teal: {
        subtlest: "#E3FAFC",
        subtler: "#C1F0F5",
        subtle: "#60C6D2",
        bolder: "#1D7F8C",
      },
      purple: {
        subtlest: "#F3F0FF",
        subtler: "#DFD8FD",
        subtle: "#9F8FEF",
        bolder: "#6E5DC6",
      },
      magenta: {
        subtlest: "#FFECF8",
        subtler: "#FDD0EC",
        subtle: "#E774BB",
        bolder: "#AE4787",
      },
      gray: {
        subtlest: "#F1F2F4",
        subtler: "#DCDFE4",
        subtle: "#8590A2",
        bolder: "#626F86",
      },
      lime: {
        subtlest: "#EEFBDA",
        subtler: "#D3F1A7",
        subtle: "#94C748",
        bolder: "#5B7F24",
      },
    },
    inverse: {
      subtle: {
        default: "#00000029",
        hovered: "#0000003d",
        pressed: "#00000052",
      },
    },
    input: {
      default: "#FFFFFF",
      hovered: "#F7F8F9",
      pressed: "#FFFFFF",
    },
    neutral: {
      default: {
        "[default]": "#091e420f",
        hovered: "#091e4224",
        pressed: "#091e4224",
      },
      subtle: {
        default: "#00000000",
        hovered: "#091e420f",
        pressed: "#091e4224",
      },
      bold: {
        default: "#44546F",
        hovered: "#2C3E5D",
        pressed: "#172B4D",
      },
    },
    brand: {
      bold: {
        default: "#0C66E4",
        hovered: "#0055CC",
        pressed: "#09326C",
      },
    },
    selected: {
      default: {
        "[default]": "#E9F2FF",
        hovered: "#CCE0FF",
        pressed: "#85B8FF",
      },
      bold: {
        default: "#0C66E4",
        hovered: "#0055CC",
        pressed: "#09326C",
      },
    },
    danger: {
      default: {
        "[default]": "#FFEDEB",
        hovered: "#FFD2CC",
        pressed: "#FF9C8F",
      },
      bold: {
        default: "#CA3521",
        hovered: "#AE2A19",
        pressed: "#601E16",
      },
    },
    warning: {
      default: {
        "[default]": "#FFF7D6",
        hovered: "#F8E6A0",
        pressed: "#F8E6A0",
      },
      bold: {
        default: "#E2B203",
        hovered: "#CF9F02",
        pressed: "#B38600",
      },
    },
    success: {
      default: {
        "[default]": "#DFFCF0",
        hovered: "#BAF3DB",
        pressed: "#7EE2B8",
      },
      bold: {
        default: "#1F845A",
        hovered: "#216E4E",
        pressed: "#164B35",
      },
    },
    discovery: {
      default: {
        "[default]": "#F3F0FF",
        hovered: "#DFD8FD",
        pressed: "#B8ACF6",
      },
      bold: {
        default: "#6E5DC6",
        hovered: "#5E4DB2",
        pressed: "#352C63",
      },
    },
    information: {
      default: {
        "[default]": "#E9F2FF",
        hovered: "#CCE0FF",
        pressed: "#85B8FF",
      },
      bold: {
        default: "#0C66E4",
        hovered: "#0055CC",
        pressed: "#09326C",
      },
    },
  },
  blanket: {
    default: "#091e427d",
    selected: "#388bff14",
    danger: "#ef5c4814",
  },
  interaction: {
    hovered: "#00000029",
    pressed: "#00000052",
  },
  skeleton: {
    default: "#091e420f",
    subtle: "#091e4208",
  },
  link: {
    default: "#0C66E4",
    pressed: "#0055CC",
    visited: "#5E4DB2",
  },
  chart: {
    brand: {
      default: "#1D7AFC",
      hovered: "#0C66E4",
    },
    neutral: {
      default: "#8590A2",
      hovered: "#758195",
    },
    success: {
      default: {
        "[default]": "#22A06B",
        hovered: "#1F845A",
      },
      bold: {
        default: "#216E4E",
        hovered: "#164B35",
      },
    },
    danger: {
      default: {
        "[default]": "#EF5C48",
        hovered: "#E34935",
      },
      bold: {
        default: "#AE2A19",
        hovered: "#601E16",
      },
    },
    warning: {
      default: {
        "[default]": "#B38600",
        hovered: "#946F00",
      },
      bold: {
        default: "#7F5F01",
        hovered: "#533F04",
      },
    },
    information: {
      default: {
        "[default]": "#388BFF",
        hovered: "#1D7AFC",
      },
      bold: {
        default: "#0055CC",
        hovered: "#09326C",
      },
    },
    discovery: {
      default: {
        "[default]": "#8F7EE7",
        hovered: "#8270DB",
      },
      bold: {
        default: "#5E4DB2",
        hovered: "#352C63",
      },
    },
    categorical: {
      "1": {
        default: "#1D9AAA",
        hovered: "#1D7F8C",
      },
      "2": {
        default: "#5E4DB2",
        hovered: "#352C63",
      },
      "3": {
        default: "#D97008",
        hovered: "#B65C02",
      },
      "4": {
        default: "#943D73",
        hovered: "#50253F",
      },
      "5": {
        default: "#09326C",
        hovered: "#092957",
      },
      "6": {
        default: "#8F7EE7",
        hovered: "#8270DB",
      },
      "7": {
        default: "#50253F",
        hovered: "#421F34",
      },
      "8": {
        default: "#974F0C",
        hovered: "#5F3811",
      },
    },
    blue: {
      bold: {
        default: "#388BFF",
        hovered: "#1D7AFC",
      },
      bolder: {
        default: "#1D7AFC",
        hovered: "#0C66E4",
      },
      boldest: {
        default: "#0055CC",
        hovered: "#09326C",
      },
    },
    red: {
      bold: {
        default: "#EF5C48",
        hovered: "#E34935",
      },
      bolder: {
        default: "#E34935",
        hovered: "#CA3521",
      },
      boldest: {
        default: "#AE2A19",
        hovered: "#601E16",
      },
    },
    orange: {
      bold: {
        default: "#D97008",
        hovered: "#B65C02",
      },
      bolder: {
        default: "#B65C02",
        hovered: "#974F0C",
      },
      boldest: {
        default: "#974F0C",
        hovered: "#5F3811",
      },
    },
    yellow: {
      bold: {
        default: "#B38600",
        hovered: "#946F00",
      },
      bolder: {
        default: "#946F00",
        hovered: "#7F5F01",
      },
      boldest: {
        default: "#7F5F01",
        hovered: "#533F04",
      },
    },
    green: {
      bold: {
        default: "#22A06B",
        hovered: "#1F845A",
      },
      bolder: {
        default: "#1F845A",
        hovered: "#216E4E",
      },
      boldest: {
        default: "#216E4E",
        hovered: "#164B35",
      },
    },
    teal: {
      bold: {
        default: "#1D9AAA",
        hovered: "#1D7F8C",
      },
      bolder: {
        default: "#1D7F8C",
        hovered: "#206B74",
      },
      boldest: {
        default: "#206B74",
        hovered: "#1D474C",
      },
    },
    purple: {
      bold: {
        default: "#8F7EE7",
        hovered: "#8270DB",
      },
      bolder: {
        default: "#8270DB",
        hovered: "#6E5DC6",
      },
      boldest: {
        default: "#5E4DB2",
        hovered: "#352C63",
      },
    },
    magenta: {
      bold: {
        default: "#DA62AC",
        hovered: "#CD519D",
      },
      bolder: {
        default: "#CD519D",
        hovered: "#AE4787",
      },
      boldest: {
        default: "#943D73",
        hovered: "#50253F",
      },
    },
    gray: {
      bold: {
        default: "#8590A2",
        hovered: "#758195",
      },
      bolder: {
        default: "#758195",
        hovered: "#626F86",
      },
      boldest: {
        default: "#44546F",
        hovered: "#2C3E5D",
      },
    },
    lime: {
      bold: {
        default: "#6A9A23",
        hovered: "#5B7F24",
      },
      bolder: {
        default: "#5B7F24",
        hovered: "#4C6B1F",
      },
      boldest: {
        default: "#4C6B1F",
        hovered: "#37471F",
      },
    },
  },
  palette: {
    Blue100: "#E9F2FF",
    Blue200: "#CCE0FF",
    Blue300: "#85B8FF",
    Blue400: "#579DFF",
    Blue500: "#388BFF",
    Blue600: "#1D7AFC",
    Blue700: "#0C66E4",
    Blue800: "#0055CC",
    Blue900: "#09326C",
    Blue1000: "#092957",
    Red100: "#FFEDEB",
    Red200: "#FFD2CC",
    Red300: "#FF9C8F",
    Red400: "#F87462",
    Red500: "#EF5C48",
    Red600: "#E34935",
    Red700: "#CA3521",
    Red800: "#AE2A19",
    Red900: "#601E16",
    Red1000: "#4F1C16",
    Yellow100: "#FFF7D6",
    Yellow200: "#F8E6A0",
    Yellow300: "#F5CD47",
    Yellow400: "#E2B203",
    Yellow500: "#CF9F02",
    Yellow600: "#B38600",
    Yellow700: "#946F00",
    Yellow800: "#7F5F01",
    Yellow900: "#533F04",
    Yellow1000: "#3F3102",
    Green100: "#DFFCF0",
    Green200: "#BAF3DB",
    Green300: "#7EE2B8",
    Green400: "#4BCE97",
    Green500: "#2ABB7F",
    Green600: "#22A06B",
    Green700: "#1F845A",
    Green800: "#216E4E",
    Green900: "#164B35",
    Green1000: "#143C2B",
    Purple100: "#F3F0FF",
    Purple200: "#DFD8FD",
    Purple300: "#B8ACF6",
    Purple400: "#9F8FEF",
    Purple500: "#8F7EE7",
    Purple600: "#8270DB",
    Purple700: "#6E5DC6",
    Purple800: "#5E4DB2",
    Purple900: "#352C63",
    Purple1000: "#15373B",
    Teal100: "#E3FAFC",
    Teal200: "#C1F0F5",
    Teal300: "#8BDBE5",
    Teal400: "#60C6D2",
    Teal500: "#37B4C3",
    Teal600: "#1D9AAA",
    Teal700: "#1D7F8C",
    Teal800: "#206B74",
    Teal900: "#1D474C",
    Teal1000: "#153337",
    Orange100: "#FFF4E5",
    Orange200: "#FFE2BD",
    Orange300: "#FEC57B",
    Orange400: "#FAA53D",
    Orange500: "#F18D13",
    Orange600: "#D97008",
    Orange700: "#B65C02",
    Orange800: "#974F0C",
    Orange900: "#5F3811",
    Orange1000: "#4A2B0F",
    Magenta100: "#FFECF8",
    Magenta200: "#FDD0EC",
    Magenta300: "#F797D2",
    Magenta400: "#E774BB",
    Magenta500: "#DA62AC",
    Magenta600: "#CD519D",
    Magenta700: "#AE4787",
    Magenta800: "#943D73",
    Magenta900: "#50253F",
    Magenta1000: "#421F34",
    Lime100: "#EEFBDA",
    Lime200: "#D3F1A7",
    Lime300: "#B3DF72",
    Lime400: "#94C748",
    Lime500: "#82B536",
    Lime600: "#6A9A23",
    Lime700: "#5B7F24",
    Lime800: "#4C6B1F",
    Lime900: "#37471F",
    Lime1000: "#2A3818",
    Neutral0: "#FFFFFF",
    Neutral100: "#F7F8F9",
    Neutral100A: "#091e4208",
    Neutral200: "#F1F2F4",
    Neutral200A: "#091e420f",
    Neutral300: "#DCDFE4",
    Neutral300A: "#091e4224",
    Neutral400: "#B3B9C4",
    Neutral400A: "#091e4224",
    Neutral500: "#8590A2",
    Neutral500A: "#091e427d",
    Neutral600: "#758195",
    Neutral700: "#626F86",
    Neutral800: "#44546F",
    Neutral900: "#2C3E5D",
    Neutral1000: "#172B4D",
    Neutral1100: "#091E42",
  },
  elevation: {
    surface: {
      default: {
        "[default]": "#FFFFFF",
        hovered: "#F1F2F4",
        pressed: "#DCDFE4",
      },
      sunken: "#F7F8F9",
      raised: {
        default: "#FFFFFF",
        hovered: "#F1F2F4",
        pressed: "#DCDFE4",
      },
      overlay: {
        default: "#FFFFFF",
        hovered: "#F1F2F4",
        pressed: "#DCDFE4",
      },
    },
    shadow: {
      raised: "0px 1px 1px 0px #091e4240, 0px 0px 1px 0px #091e424f",
      overflow: {
        default: "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480",
        spread: "#091e4229",
        perimeter: "#091e421f",
      },
      overlay: "0px 8px 12px 0px #091e4226, 0px 0px 1px 0px #091e424f",
    },
  },
};
